import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const analyticsApiService = createApi({
  reducerPath: "analyticsApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getFitnessCourse: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `analytics/fitness-course-data${query}`;
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetFitnessCourseQuery } = analyticsApiService;
